// Lucide, ISC license. Source pinned to 7b0196e249ca09ca27c584c497aca9a8cab8a7f5.
// Only the icons used by RotaFlex are bundled; see assets/icons/LICENSE.txt.
export const iconPaths = {
  "phone": [
    {
      "tag": "path",
      "attrs": {
        "d": "M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"
      }
    }
  ],
  "dashboard": [
    {
      "tag": "path",
      "attrs": {
        "d": "m12 14 4-4"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M3.34 19a10 10 0 1 1 17.32 0"
      }
    }
  ],
  "orders": [
    {
      "tag": "rect",
      "attrs": {
        "width": "8",
        "height": "4",
        "x": "8",
        "y": "2",
        "rx": "1",
        "ry": "1"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M12 11h4"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M12 16h4"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M8 11h.01"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M8 16h.01"
      }
    }
  ],
  "import": [
    {
      "tag": "path",
      "attrs": {
        "d": "M4 11V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-1"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M14 2v5a1 1 0 0 0 1 1h5"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M2 15h10"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "m9 18 3-3-3-3"
      }
    }
  ],
  "bell": [
    {
      "tag": "path",
      "attrs": {
        "d": "M10.268 21a2 2 0 0 0 3.464 0"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326"
      }
    }
  ],
  "fleet": [
    {
      "tag": "path",
      "attrs": {
        "d": "M4 6 2 7"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M10 6h4"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "m22 7-2-1"
      }
    },
    {
      "tag": "rect",
      "attrs": {
        "width": "16",
        "height": "16",
        "x": "4",
        "y": "3",
        "rx": "2"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M4 11h16"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M8 15h.01"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M16 15h.01"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M6 19v2"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M18 21v-2"
      }
    }
  ],
  "document": [
    {
      "tag": "path",
      "attrs": {
        "d": "M15 2h-4a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M16.706 2.706A2.4 2.4 0 0 0 15 2v5a1 1 0 0 0 1 1h5a2.4 2.4 0 0 0-.706-1.706z"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M5 7a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h8a2 2 0 0 0 1.732-1"
      }
    }
  ],
  "report": [
    {
      "tag": "path",
      "attrs": {
        "d": "M12 16v5"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M16 14.639V21"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M20 10.656V21"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "m22 3-8.646 8.646a.5.5 0 0 1-.708 0L9.354 8.354a.5.5 0 0 0-.707 0L2 15"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M4 18.463V21"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M8 14.656V21"
      }
    }
  ],
  "card": [
    {
      "tag": "rect",
      "attrs": {
        "width": "20",
        "height": "14",
        "x": "2",
        "y": "5",
        "rx": "2"
      }
    },
    {
      "tag": "line",
      "attrs": {
        "x1": "2",
        "x2": "22",
        "y1": "10",
        "y2": "10"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M6 14h2"
      }
    }
  ],
  "people": [
    {
      "tag": "path",
      "attrs": {
        "d": "M18 21a8 8 0 0 0-16 0"
      }
    },
    {
      "tag": "circle",
      "attrs": {
        "cx": "10",
        "cy": "8",
        "r": "5"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3"
      }
    }
  ],
  "person": [
    {
      "tag": "path",
      "attrs": {
        "d": "M16 2v2"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M17.915 21a6 6 0 10-12 0"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M8 2v2"
      }
    },
    {
      "tag": "circle",
      "attrs": {
        "cx": "12",
        "cy": "11",
        "r": "4"
      }
    },
    {
      "tag": "rect",
      "attrs": {
        "x": "3",
        "y": "3",
        "width": "18",
        "height": "18",
        "rx": "2"
      }
    }
  ],
  "driver": [
    {
      "tag": "path",
      "attrs": {
        "d": "M16 2v2"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M17.915 21a6 6 0 10-12 0"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M8 2v2"
      }
    },
    {
      "tag": "circle",
      "attrs": {
        "cx": "12",
        "cy": "11",
        "r": "4"
      }
    },
    {
      "tag": "rect",
      "attrs": {
        "x": "3",
        "y": "3",
        "width": "18",
        "height": "18",
        "rx": "2"
      }
    }
  ],
  "building": [
    {
      "tag": "path",
      "attrs": {
        "d": "M12 10h.01"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M12 14h.01"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M12 6h.01"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M16 10h.01"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M16 14h.01"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M16 6h.01"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M8 10h.01"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M8 14h.01"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M8 6h.01"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M9 22v-3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3"
      }
    },
    {
      "tag": "rect",
      "attrs": {
        "x": "4",
        "y": "2",
        "width": "16",
        "height": "20",
        "rx": "2"
      }
    }
  ],
  "history": [
    {
      "tag": "path",
      "attrs": {
        "d": "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M3 3v5h5"
      }
    }
  ],
  "shield": [
    {
      "tag": "path",
      "attrs": {
        "d": "m14.305 19.53.923-.382"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "m15.228 16.852-.923-.383"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "m16.852 15.228-.383-.923"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "m16.852 20.772-.383.924"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "m19.148 15.228.383-.923"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "m19.53 21.696-.382-.924"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M2 21a8 8 0 0 1 10.434-7.62"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "m20.772 16.852.924-.383"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "m20.772 19.148.924.383"
      }
    },
    {
      "tag": "circle",
      "attrs": {
        "cx": "10",
        "cy": "8",
        "r": "5"
      }
    },
    {
      "tag": "circle",
      "attrs": {
        "cx": "18",
        "cy": "18",
        "r": "3"
      }
    }
  ],
  "route": [
    {
      "tag": "circle",
      "attrs": {
        "cx": "6",
        "cy": "19",
        "r": "3"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15"
      }
    },
    {
      "tag": "circle",
      "attrs": {
        "cx": "18",
        "cy": "5",
        "r": "3"
      }
    }
  ],
  "refresh": [
    {
      "tag": "path",
      "attrs": {
        "d": "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M21 3v5h-5"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M8 16H3v5"
      }
    }
  ],
  "plus": [
    {
      "tag": "path",
      "attrs": {
        "d": "M5 12h14"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M12 5v14"
      }
    }
  ],
  "search": [
    {
      "tag": "path",
      "attrs": {
        "d": "m21 21-4.34-4.34"
      }
    },
    {
      "tag": "circle",
      "attrs": {
        "cx": "11",
        "cy": "11",
        "r": "8"
      }
    }
  ],
  "warning": [
    {
      "tag": "path",
      "attrs": {
        "d": "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M12 9v4"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M12 17h.01"
      }
    }
  ],
  "lock": [
    {
      "tag": "circle",
      "attrs": {
        "cx": "12",
        "cy": "16",
        "r": "1"
      }
    },
    {
      "tag": "rect",
      "attrs": {
        "x": "3",
        "y": "10",
        "width": "18",
        "height": "12",
        "rx": "2"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M7 10V7a5 5 0 0 1 10 0v3"
      }
    }
  ],
  "logout": [
    {
      "tag": "path",
      "attrs": {
        "d": "m16 17 5-5-5-5"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M21 12H9"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"
      }
    }
  ],
  "menu": [
    {
      "tag": "rect",
      "attrs": {
        "width": "18",
        "height": "18",
        "x": "3",
        "y": "3",
        "rx": "2"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M9 3v18"
      }
    }
  ],
  "close": [
    {
      "tag": "path",
      "attrs": {
        "d": "M18 6 6 18"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "m6 6 12 12"
      }
    }
  ],
  "check": [
    {
      "tag": "path",
      "attrs": {
        "d": "M20 6 9 17l-5-5"
      }
    }
  ],
  "send": [
    {
      "tag": "path",
      "attrs": {
        "d": "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "m21.854 2.147-10.94 10.939"
      }
    }
  ],
  "edit": [
    {
      "tag": "path",
      "attrs": {
        "d": "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "m15 5 4 4"
      }
    }
  ],
  "trash": [
    {
      "tag": "path",
      "attrs": {
        "d": "M10 11v6"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M14 11v6"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M3 6h18"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
      }
    }
  ],
  "back": [
    {
      "tag": "path",
      "attrs": {
        "d": "m12 19-7-7 7-7"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M19 12H5"
      }
    }
  ],
  "download": [
    {
      "tag": "path",
      "attrs": {
        "d": "M12 15V3"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "m7 10 5 5 5-5"
      }
    }
  ],
  "eye": [
    {
      "tag": "path",
      "attrs": {
        "d": "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"
      }
    },
    {
      "tag": "circle",
      "attrs": {
        "cx": "12",
        "cy": "12",
        "r": "3"
      }
    }
  ],
  "eye-off": [
    {
      "tag": "path",
      "attrs": {
        "d": "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M14.084 14.158a3 3 0 0 1-4.242-4.242"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "m2 2 20 20"
      }
    }
  ],
  "receipt": [
    {
      "tag": "path",
      "attrs": {
        "d": "M13 16H8"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M14 8H8"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M16 12H8"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M4 3a1 1 0 0 1 1-1 1.3 1.3 0 0 1 .7.2l.933.6a1.3 1.3 0 0 0 1.4 0l.934-.6a1.3 1.3 0 0 1 1.4 0l.933.6a1.3 1.3 0 0 0 1.4 0l.933-.6a1.3 1.3 0 0 1 1.4 0l.934.6a1.3 1.3 0 0 0 1.4 0l.933-.6A1.3 1.3 0 0 1 19 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1 1.3 1.3 0 0 1-.7-.2l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.934.6a1.3 1.3 0 0 1-1.4 0l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-1.4 0l-.934-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-.7.2 1 1 0 0 1-1-1z"
      }
    }
  ],
  "layers": [
    {
      "tag": "path",
      "attrs": {
        "d": "M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17"
      }
    }
  ],
  "pin": [
    {
      "tag": "path",
      "attrs": {
        "d": "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"
      }
    },
    {
      "tag": "circle",
      "attrs": {
        "cx": "12",
        "cy": "10",
        "r": "3"
      }
    }
  ],
  "arrow-right": [
    {
      "tag": "path",
      "attrs": {
        "d": "M5 12h14"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "m12 5 7 7-7 7"
      }
    }
  ],
  "chevron-down": [
    {
      "tag": "path",
      "attrs": {
        "d": "m6 9 6 6 6-6"
      }
    }
  ],
  "chevron-right": [
    {
      "tag": "path",
      "attrs": {
        "d": "m9 18 6-6-6-6"
      }
    }
  ],
  "copy": [
    {
      "tag": "rect",
      "attrs": {
        "width": "14",
        "height": "14",
        "x": "8",
        "y": "8",
        "rx": "2",
        "ry": "2"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"
      }
    }
  ],
  "calendar": [
    {
      "tag": "path",
      "attrs": {
        "d": "M8 2v3"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M16 2v3"
      }
    },
    {
      "tag": "rect",
      "attrs": {
        "x": "3",
        "y": "3",
        "width": "18",
        "height": "18",
        "rx": "2"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M3 9h18"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M8 13h.01"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M12 13h.01"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M16 13h.01"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M8 17h.01"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M12 17h.01"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M16 17h.01"
      }
    }
  ],
  "clock": [
    {
      "tag": "circle",
      "attrs": {
        "cx": "12",
        "cy": "12",
        "r": "10"
      }
    },
    {
      "tag": "path",
      "attrs": {
        "d": "M12 6v6l4 2"
      }
    }
  ]
};
